import React from 'react';
import { IButton } from '../../../types';

const Button: React.FC<IButton> = ({ text, outlined, clickHandler, step }) => {
  return (
    <div className={`calculator__button ${outlined ? "calculator__button--outlined" : "calculator__button--default"}`}>
      <div className="calculator__button__inner">
        <button data-step={step} onClick={(e) => clickHandler(e)} className={`calculator__button__content ${outlined ? "calculator__button__content--outlined" : "calculator__button__content--default"}`}>
          {text}
        </button>
      </div>
    </div>
  );
}

export default Button;